import React, { ReactNode } from "react";
import './styles.scss'

interface DrawerProps {
  children: ReactNode;
}

function Drawer({ children }: DrawerProps) {
  return <div className="drawer">{children}</div>;
}

export { Drawer };
